import Spinner from "../loader/Spinner";

const PageLoader = ({
  children,
  isFetching,
}: {
  children: React.ReactNode;
  isFetching: boolean;
}) => {
  return isFetching ? <Spinner /> : <>{children}</>;
};

export default PageLoader;
